import React, { useState, useEffect } from "react";
import {
  GithubIcon,
  LinkedinIcon,
  InstagramIcon,
  MailIcon,
  HeartIcon,
} from "lucide-react";

export default function Footer({ onOpenAdmin }) {
  const currentYear = new Date().getFullYear();
  const [isVisible, setIsVisible] = useState(false);
  const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleSecretHeartClick = () => {
    const nextCount = clickCount + 1;
    if (nextCount >= 5) {
      setClickCount(0);
      if (onOpenAdmin) onOpenAdmin();
    } else {
      setClickCount(nextCount);
      // Reset count after 3 seconds of inactivity
      setTimeout(() => setClickCount(0), 3000);
    }
  };

  const socialLinks = [
    { 
      icon: GithubIcon, 
      href: "https://github.com", 
      label: "GitHub"
    },
    { 
      icon: LinkedinIcon, 
      href: "https://linkedin.com", 
      label: "LinkedIn"
    },
    { 
      icon: InstagramIcon, 
      href: "#", 
      label: "Instagram"
    },
    { 
      icon: MailIcon, 
      href: "mailto:wishmitha0720@gmail.com", 
      label: "Email"
    }
  ];

  return (
    <footer className="bg-transparent py-6 px-4 sm:px-6 lg:px-8 border-t border-white/5">
      <div className="max-w-5xl mx-auto">
        {/* Main centered content - minimal height */}
        <div className="flex flex-col items-center justify-center py-2">

          {/* Copyright Text */}
          <div className="text-center select-none">
            <p className="text-slate-400 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-1">
              © {currentYear} Wishmitha Devinda. Built with
              <span
                onClick={handleSecretHeartClick}
                title={clickCount > 0 ? `${5 - clickCount} clicks to admin` : ''}
                className="cursor-pointer inline-flex items-center hover:scale-125 transition-transform"
              >
                <HeartIcon className="w-3.5 h-3.5 text-[#4779c4] fill-[#4779c4] mx-1 transition-all" />
              </span>
              passion and creativity.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}